import * as React from 'react';
import * as DateHelpers from './DateHelpers';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions, DownloadFile } from './Shared';

const ReportInvoicesSentToReckonData = () => {
    let navigate = useNavigate();
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [sentDate, setSentDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunInvoicesSentToReckonReport");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const handleSentDateChange = (e: any) => {
        let error = errors;
        delete error["sentDate"];
        setErrors(error);

        setSentDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!sentDate) {
            formIsValid = false;
            errorList["sentDate"] = "Sent Date is required";
        }

        if (!DateHelpers.isValidDate(sentDate)) {
            formIsValid = false;
            errorList["sentDate"] = "Sent Date must be < End Date";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const apiURL = 'ExportInvoicesSentByDate?InvoiceSentDate=' + sentDate;
        var filename = "Invoices Sent To Reckon.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Invoices Sent to Reckon Report</h1>
            </div>
            <div className="marginTop20">
                <div>Report showing all invoices sent to Reckon on the selected date.</div>
                <span>Select a Sent Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="sentDate">
                    <span className="label">Sent Date</span>
                    <input type='date' id="sentDate" name="sentDate" className='input' value={sentDate} onChange={(e) => handleSentDateChange(e)}></input>
                </label>
                <span className={errors["sentDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["sentDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportInvoicesSentToReckonData;